import { Component } from "react"

/* Modal */
import Modal from "react-modal"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../../translates/translate"

/* REST API */
import { create } from "../../api/Game"

/* Helpers */
import { utils } from "../../helpers"

/* Icons */
import { CloseIcon, CheckIcon, PlusIcon, InfoIcon, BackIcon, ArrowIcon, TrashIcon, TableIcon, LayersIcon, SlidersIcon, SearchIcon, CoinIcon, StudioIcon, TypeIcon } from "./GameIcons"

/* Switch */
import Switch from "react-switch"

/* Sweet alert */
import Swal from "../../helpers/alert"


/* THE STEPS OF THE FORM */
const STEPS = ["game", "table", "currency"]

/* THE CHIPS EVERY NEW CURRENCY STARTS WITH */
/* THE DEFAULT LIMITS OF A TABLE — THE VALUES OF THE DOLLAR, EVERY OTHER CURRENCY MULTIPLIES THEM BY ITS CHIP RATE */
const DEFAULT = {
    min: 1,
    max: 1000,
    maxPay: 10000,
    chips: [
        { value: 1, color: "#303030" },
        { value: 5, color: "#be0022" },
        { value: 25, color: "#089e0c" },
        { value: 100, color: "#858585" },
        { value: 500, color: "#0749a0" },
        { value: 1000, color: "#fd7549" },
    ],
}


/* THE CHIP RATE OF A CURRENCY — AN EMPTY OR BROKEN COLUMN COUNTS AS ONE */
const getRate = (currency) => {

    /* Fields */
    const rate = currency ? parseInt(currency.chipRate) : 1

    /* Send Result */
    return !rate || isNaN(rate) || rate < 1 ? 1 : rate
}


/* THE LIMITS OF A CURRENCY — THE RATE TURNS THE VALUES OF THE DOLLAR INTO THE ONES OF THE CURRENCY */
const getLimits = (currency) => {

    /* Fields */
    const rate = getRate(currency)

    /* Send Result */
    return {
        currencyID: currency.id,
        min: `${DEFAULT.min * rate}`,
        max: `${DEFAULT.max * rate}`,
        maxPay: `${DEFAULT.maxPay * rate}`,
        chips: DEFAULT.chips.map((item) => `${item.value * rate}-${item.color}`).join(","),
    }
}

/* EMPTY FORM STATE */
const EMPTY = {

    /* Navigation */
    step: "game",

    /* Selection */
    typeID: 0,
    game: "",
    search: "",

    /* Table — the visibility of the table is NOT called "visible", that name belongs to the modal itself */
    name: "",
    slug: "",
    studioID: "",
    room: "",
    gameURL: "",
    backURL: "",
    rtp: "",
    tableVisible: true,

    /* Limits — one row per chosen currency */
    limits: [],

    waiting: false,
    error: "",
}


/* Widget Game Form */
class GameForm extends Component {

    constructor() {
        super()
        this.state = { visible: false, ...EMPTY }
    }

    /* Open Action */
    open = () => {

        /* Fields */
        const { catalog } = this.props

        /* The First Type Is Preselected So The List Is Never Empty */
        const first = catalog.types.length > 0 ? catalog.types[0].id : 0

        /* The Only Studio Of The Admin Is Preselected */
        const studioID = catalog.studios.length === 1 ? `${catalog.studios[0].id}` : ""

        this.setState({ visible: true, ...EMPTY, typeID: first, studioID })
    }

    /* Close Action */
    close = () => {
        this.setState({ visible: false, ...EMPTY })
    }

    /* Error Message Of A Response */
    message = (response) => {

        /* Check Status */
        if (response && response.status === 409) {
            return t("game.error.duplicate")
        }

        /* Check Status */
        if (response && response.status === 498) {
            return t("swal.invalidKey")
        }

        /* Check Status */
        if (response && (response.status === 401 || response.status === 403)) {
            return t("swal.noAccess")
        }

        /* Check Message */
        if (response && response.data && response.data.message) {
            return response.data.message
        }

        /* Send Result */
        return t("swal.generic")
    }


    /* The Selected Type */
    type = () => {

        /* Fields */
        const { catalog } = this.props
        const { typeID } = this.state

        /* Send Result */
        return catalog.types.find((item) => parseInt(item.id) === parseInt(typeID))
    }

    /* Is The Selected Type Dealt In A Studio */
    isLive = () => {

        /* Fields */
        const type = this.type()

        /* Send Result */
        return type ? parseInt(type.live) === 1 : false
    }

    /* Games Of The Selected Type */
    games = () => {

        /* Fields */
        const { catalog } = this.props
        const { typeID, search } = this.state

        /* Filter By Type */
        const list = catalog.games.filter((item) => parseInt(item.typeID) === parseInt(typeID) && parseInt(item.visible) === 1)

        /* Check Search */
        if (!search) {
            return list
        }

        /* Filter By Search */
        const value = search.toLowerCase()

        return list.filter((item) => `${item.name} ${item.key}`.toLowerCase().includes(value))
    }

    /* Select A Type — the game of another type must not stay selected */
    selectType = (id) => {

        /* Fields */
        const { game } = this.state
        const { catalog } = this.props

        /* Check The Selected Game */
        const selected = catalog.games.find((item) => item.key === game)
        const keep = selected && parseInt(selected.typeID) === parseInt(id)

        this.setState({ typeID: id, game: keep ? game : "", search: "" })
    }

    /* Select A Game — its name prefills the empty name of the table */
    selectGame = (item) => {

        /* Fields */
        const { name } = this.state

        this.setState({ game: item.key, name: name ? name : item.name })
    }

    /* Toggle A Currency Of The Table */
    toggleCurrency = (currency) => {

        /* Fields */
        const { limits } = this.state

        /* Check The Currency */
        const exists = limits.find((item) => parseInt(item.currencyID) === parseInt(currency.id))

        /* Remove The Currency */
        if (exists) {
            this.setState({ limits: limits.filter((item) => parseInt(item.currencyID) !== parseInt(currency.id)) })
            return
        }

        /* Add The Currency — it comes filled with the default limits of its rate */
        this.setState({ limits: [...limits, getLimits(currency)] })
    }

    /* Change A Limit Of A Currency */
    /* Выбрать все валюты — у уже добавленных лимиты сохраняются, новым ставятся значения по коэффициенту */
    selectAllCurrencies = () => {

        /* Fields */
        const { catalog } = this.props
        const { limits } = this.state

        /* Send Result */
        this.setState({
            limits: catalog.currencies.map((item) => {
                const exists = limits.find((row) => parseInt(row.currencyID) === parseInt(item.id))
                return exists ? exists : getLimits(item)
            }),
        })
    }

    /* Убрать все валюты */
    clearCurrencies = () => {
        this.setState({ limits: [] })
    }

    changeLimit = (currencyID, key, value) => {

        /* Fields */
        const { limits } = this.state

        this.setState({
            limits: limits.map((item) => parseInt(item.currencyID) === parseInt(currencyID) ? { ...item, [key]: value } : item),
        })
    }


    /* The Step After The Current One */
    next = () => {

        /* Fields */
        const { step } = this.state

        /* Check The Game */
        if (step === "game") {

            /* Check Selection */
            if (!this.state.game) {
                this.setState({ error: t("game.error.selectGame") })
                return
            }

            this.setState({ step: "table", error: "" })
            return
        }

        /* Check The Table */
        if (step === "table") {

            /* Check The Fields */
            const error = this.check()

            /* Check Error */
            if (error) {
                this.setState({ error })
                return
            }

            this.setState({ step: "currency", error: "" })
            return
        }

        /* The Last Step Creates The Table */
        this.save()
    }

    /* The Step Before The Current One */
    back = () => {

        /* Fields */
        const { step } = this.state
        const index = STEPS.indexOf(step)

        /* Check Index */
        if (index <= 0) {
            return
        }

        this.setState({ step: STEPS[index - 1], error: "" })
    }

    /* Go To A Step — a step ahead of the selection stays locked */
    go = (step) => {

        /* Check The Game */
        if (step !== "game" && !this.state.game) {
            return
        }

        this.setState({ step, error: "" })
    }

    /* Check The Fields Of The Table */
    check = () => {

        /* Fields */
        const { name, slug, studioID } = this.state

        /* Check Name */
        if (!name) {
            return t("game.error.emptyName")
        }

        /* Check Key */
        if (!slug) {
            return t("game.error.emptyKey")
        }

        /* Check Key */
        if (/[^a-z0-9-]/.test(slug)) {
            return t("game.error.invalidKey")
        }

        /* Check Studio — a live game is always dealt in a studio */
        if (this.isLive() && !studioID) {
            return t("game.error.selectStudio")
        }

        /* Send Result */
        return ""
    }

    /* Create A Table */
    save = () => {

        /* Fields */
        const { name, slug, game, studioID, room, gameURL, backURL, rtp, tableVisible, limits, waiting } = this.state
        const { reload } = this.props

        /* Check Waiting */
        if (waiting) {
            return
        }

        /* Check Game */
        if (!game) {
            this.setState({ step: "game", error: t("game.error.selectGame") })
            return
        }

        /* Check The Fields */
        const error = this.check()

        /* Check Error */
        if (error) {
            this.setState({ step: "table", error })
            return
        }

        /* Start Waiting */
        this.setState({ waiting: true, error: "" })

        /* Send to REST API */
        create({
            name,
            slug,
            game,
            studioID: studioID ? studioID : null,
            room,
            gameURL,
            backURL,
            rtp,
            visible: tableVisible,
            currencies: limits,
        }).then((response) => {
            if (response.status === 200) {
                Swal.fire(utils.notification(t("game.addedSuccess"), "success"))
                reload()
                this.close()
            }
            else {
                Swal.fire(utils.notification(this.message(response), "error"))
            }
        }).catch(() => {
            Swal.fire(utils.notification(t("swal.generic"), "error"))
        }).finally(() => {
            this.setState({ waiting: false })
        })
    }


    /* Draw A Field */
    _field = (label, value, onChange, options = {}) => (
        <div className={`gm--field ${options.full ? "gm--full" : ""}`}>

            <label>{label}{options.required ? <i>*</i> : null}</label>

            <input value={value} placeholder={options.placeholder ? options.placeholder : ""} onChange={(event) => onChange(event.target.value)} />

            {options.hint ? <small>{options.hint}</small> : null}

        </div>
    )

    /* Draw The Step Of The Game */
    _game = () => {

        /* Fields */
        const { catalog, admin } = this.props
        const { typeID, game, search } = this.state

        /* Games Of The Type */
        const list = this.games()

        return (
            <div>

                <div className="gm--section">

                    <div className="gm--section-title">
                        <LayersIcon size={13} />
                        {t("game.typeSection")}
                    </div>

                    <div className="gm--types">
                        {catalog.types.map((item) =>
                            <div onClick={() => this.selectType(item.id)} className={`gm--type ${parseInt(typeID) === parseInt(item.id) ? "active" : ""}`} key={`${item.id}`}>
                                <div className="gm--type-icon"><TypeIcon type={item.key} size={18} /></div>
                                <div className="gm--type-name">{item.name}</div>
                                {parseInt(item.live) === 1 ? <div className="gm--type-live">Live</div> : null}
                            </div>
                        )}
                    </div>

                </div>

                <div className="gm--section">

                    <div className="gm--section-head">

                        <div className="gm--section-title">
                            <TableIcon size={13} />
                            {t("game.gameSection")}
                        </div>

                        <div className="gm--search">
                            <SearchIcon />
                            <input value={search} placeholder={t("common.search")} onChange={(event) => this.setState({ search: event.target.value })} />
                        </div>

                    </div>

                    <div className="gm--games">

                        {list.map((item) =>
                            <div onClick={() => this.selectGame(item)} className={`gm--game ${item.color} ${game === item.key ? "active" : ""}`} key={`${item.id}`}>

                                <div className="gm--game-text">
                                    <div className="gm--game-name">{item.name}</div>
                                    <div className="gm--game-key">{item.prefix ? `${item.prefix} · ${item.key}` : item.key}</div>
                                </div>

                                <div className="gm--game-check"><CheckIcon /></div>

                            </div>
                        )}

                        {list.length === 0 ? <div className="gm--empty">{t("game.emptyType")}</div> : null}

                    </div>

                    {
                        admin && admin.access === "superadmin" ?
                            <div className="gm--hint">
                                <InfoIcon size={14} />
                                <span>{t("game.catalogHint")}</span>
                            </div>
                            : null
                    }

                </div>

            </div>
        )
    }

    /* Draw The Step Of The Table */
    _table = () => {

        /* Fields */
        const { catalog } = this.props
        const { name, slug, studioID, room, gameURL, backURL, rtp, tableVisible } = this.state

        /* The Studio Is Mandatory For A Live Game Only */
        const live = this.isLive()

        return (
            <div>

                <div className="gm--section">

                    <div className="gm--section-title">
                        <SlidersIcon size={13} />
                        {t("game.tableSection")}
                    </div>

                    <div className="gm--grid">

                        {this._field(t("game.tableName"), name, (value) => this.setState({ name: value }), { required: true })}
                        {this._field(t("game.tableKey"), slug, (value) => this.setState({ slug: value.toLowerCase() }), { required: true, hint: t("game.keyHint") })}

                        <div className="gm--field">

                            <label>{t("game.studio")}{live ? <i>*</i> : null}</label>

                            <select value={studioID} onChange={(event) => this.setState({ studioID: event.target.value })}>
                                <option value="">{t("game.noStudio")}</option>
                                {catalog.studios.map((item) => <option value={`${item.id}`} key={`${item.id}`}>{item.name}</option>)}
                            </select>

                            <small>{live ? t("game.studioLive") : t("game.studioOptional")}</small>

                        </div>

                        {this._field("Room", room, (value) => this.setState({ room: value }), { hint: t("game.roomHint") })}

                    </div>

                </div>

                <div className="gm--section">

                    <div className="gm--section-title">
                        <StudioIcon size={13} />
                        {t("game.addressSection")}
                    </div>

                    <div className="gm--grid">

                        {this._field(t("game.gameURL"), gameURL, (value) => this.setState({ gameURL: value }))}
                        {this._field(t("game.serverURL"), backURL, (value) => this.setState({ backURL: value }))}

                        {live ? null : this._field("RTP", rtp, (value) => this.setState({ rtp: value }), { placeholder: "97.5", hint: t("game.rtpHint") })}

                        <div className="gm--field gm--full">

                            <div className="gm--switch">

                                <div className="gm--switch-text">
                                    <b>{t("game.tableVisibility")}</b>
                                    <span>{t("game.visibilityHint")}</span>
                                </div>

                                <Switch uncheckedIcon={false} checkedIcon={false} onColor="#8bc34a" onChange={(value) => this.setState({ tableVisible: value })} checked={tableVisible} />

                            </div>

                        </div>

                    </div>

                </div>

            </div>
        )
    }

    /* Draw The Step Of The Currencies */
    _currency = () => {

        /* Fields */
        const { catalog } = this.props
        const { limits } = this.state

        return (
            <div>

                <div className="gm--section">

                    <div className="gm--section-head">

                        <div className="gm--section-title">
                            <CoinIcon size={13} />
                            {t("game.currencySection")}
                        </div>

                        <div className="gm--currency-actions">
                            <div
                                onClick={() => this.selectAllCurrencies()}
                                className={`gm--currency-action ${limits.length === catalog.currencies.length ? "disabled" : ""}`}
                            >
                                {t("game.selectAllCurrencies")}
                            </div>
                            <div
                                onClick={() => this.clearCurrencies()}
                                className={`gm--currency-action ${limits.length === 0 ? "disabled" : ""}`}
                            >
                                {t("game.clearCurrencies")}
                            </div>
                        </div>

                    </div>

                    <div className="gm--currencies">
                        {catalog.currencies.map((item) =>
                            <div onClick={() => this.toggleCurrency(item)} className={`gm--currency ${limits.find((row) => parseInt(row.currencyID) === parseInt(item.id)) ? "active" : ""}`} key={`${item.id}`}>
                                {item.code}
                            </div>
                        )}
                    </div>

                    {
                        limits.map((row) => {

                            /* The Currency Of The Row */
                            const currency = catalog.currencies.find((item) => parseInt(item.id) === parseInt(row.currencyID))

                            return (
                                <div className="gm--limit" key={`${row.currencyID}`}>

                                    <div className="gm--limit-head">

                                        <div className="gm--limit-name">
                                            <div className="gm--limit-code">{currency ? currency.code : ""}</div>
                                            {currency ? currency.name : ""}
                                            {getRate(currency) > 1 ? <span className="gm--limit-rate">× {getRate(currency)}</span> : null}
                                        </div>

                                        <div onClick={() => this.toggleCurrency({ id: row.currencyID })} className="gm--limit-remove">
                                            <TrashIcon size={14} />
                                        </div>

                                    </div>

                                    <div className="gm--grid gm--grid-3">

                                        {this._field(t("game.min"), row.min, (value) => this.changeLimit(row.currencyID, "min", value))}
                                        {this._field(t("game.max"), row.max, (value) => this.changeLimit(row.currencyID, "max", value))}
                                        {this._field(t("game.maxPay"), row.maxPay, (value) => this.changeLimit(row.currencyID, "maxPay", value))}

                                        <div className="gm--full">
                                            {this._field(t("game.chips"), row.chips, (value) => this.changeLimit(row.currencyID, "chips", value), { hint: t("game.chipsHint") })}
                                        </div>

                                    </div>

                                </div>
                            )
                        })
                    }

                    {limits.length === 0 ? <div className="gm--empty">{t("game.emptyCurrency")}</div> : null}

                    <div className="gm--hint">
                        <InfoIcon size={14} />
                        <span>{t("game.currencyHint")}</span>
                    </div>

                </div>

            </div>
        )
    }

    /* Draw A Step Of The Side Column */
    _step = (key, index, title, subtitle) => {

        /* Fields */
        const { step, game } = this.state

        /* A Step Ahead Of The Selection Stays Locked */
        const locked = key !== "game" && !game
        const done = STEPS.indexOf(key) < STEPS.indexOf(step)

        return (
            <div onClick={() => this.go(key)} className={`gm--step ${step === key ? "active" : ""} ${done ? "done" : ""} ${locked ? "disabled" : ""}`}>

                <div className="gm--step-num">{done ? <CheckIcon /> : index}</div>

                <div className="gm--step-text">
                    <b>{title}</b>
                    <span>{subtitle}</span>
                </div>

            </div>
        )
    }

    render = () => {

        /* Fields */
        const { catalog } = this.props
        const { visible, waiting, step, game, name, studioID, limits, error } = this.state

        /* The Selected Game And Studio */
        const selected = catalog.games.find((item) => item.key === game)
        const studio = catalog.studios.find((item) => parseInt(item.id) === parseInt(studioID))
        const type = this.type()

        return (
            <Modal
                isOpen={visible}
                onRequestClose={() => this.close()}
                className="gm--modal"
                overlayClassName="gm--overlay"
                closeTimeoutMS={200}
            >

                <div className="gm--head">

                    <div className="gm--head-icon">
                        <TableIcon size={18} />
                    </div>

                    <div className="gm--head-text">
                        <h2>{t("game.addTitle")}</h2>
                        <p>{t("game.addSubtitle")}</p>
                    </div>

                    <div onClick={() => this.close()} className="gm--close">
                        <CloseIcon />
                    </div>

                </div>

                <div className="gm--body">

                    <div className="gm--side">

                        {this._step("game", 1, t("game.stepGame"), selected ? selected.name : t("game.stepGameHint"))}
                        {this._step("table", 2, t("game.stepTable"), name ? name : t("game.stepTableHint"))}
                        {this._step("currency", 3, t("game.stepCurrency"), limits.length > 0 ? `${limits.length}` : t("game.stepCurrencyHint"))}

                        <div className="gm--summary">

                            <div className="gm--summary-row">
                                <span>{t("game.typeSection")}</span>
                                <b>{type ? type.name : "—"}</b>
                            </div>

                            <div className="gm--summary-row">
                                <span>{t("game.studio")}</span>
                                <b>{studio ? studio.name : "—"}</b>
                            </div>

                            <div className="gm--summary-row">
                                <span>{t("game.currencySection")}</span>
                                <b>{limits.length > 0 ? limits.length : "—"}</b>
                            </div>

                        </div>

                    </div>

                    <div className="gm--content">
                        {step === "game" ? this._game() : null}
                        {step === "table" ? this._table() : null}
                        {step === "currency" ? this._currency() : null}
                    </div>

                </div>

                <div className="gm--foot">

                    <div className="gm--foot-note">{error ? error : ""}</div>

                    {
                        step === "game" ?
                            <div onClick={() => this.close()} className="gm--button ghost">{t("common.cancel")}</div>
                            :
                            <div onClick={() => this.back()} className="gm--button ghost"><BackIcon />{t("common.back")}</div>
                    }

                    <div onClick={() => this.next()} className={`gm--button primary ${waiting ? "waiting" : ""}`}>
                        {
                            waiting ? <div className="gm--loading" />
                                : step === "currency" ? <><PlusIcon size={15} />{t("common.save")}</>
                                    : <>{t("common.next")}<ArrowIcon /></>
                        }
                    </div>

                </div>

            </Modal>
        )
    }
}


const mapStateToProps = (state) => ({
    language: state.language,
    catalog: state.catalog,
    admin: state.admin,
})

export default connect(mapStateToProps, null, null, { forwardRef: true })(GameForm)
